export const SET_ALERT = "SET_ALERT";
export const REMOVE_ALERT = "REMOVE_ALERT";
export const REGISTER_SUCCESS = "REGISTER_SUCCESS";
export const REGISTER_FAIL = "REGISTER_FAIL";
export const USER_LOADED = "USER_LOADED";
export const AUTH_ERROR = "AUTH_ERROR";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAIL = "LOGIN_FAIL";
export const LOGOUT = "LOGOUT";
export const GET_PROFILE = "GET_PROFILE";
// Volunteer
export const ADD_VOLUNTEER_SUCCESS = "ADD_VOLUNTEER_SUCCESS";
export const LIST_VOLUNTEERS = "LIST_VOLUNTEERS";
export const TOTAL_VOLUNTEERS = "TOTAL_VOLUNTEERS";

export const VIEW_VOLUNTEER = "VIEW_VOLUNTEER";
export const VOLUNTEER_ERROR = "VOLUNTEER_ERROR";
export const ADD_VOLUNTEER = "ADD_VOLUNTEER";
// Students
export const ADD_STUDENT = "ADD_STUDENT";
export const TOTAL_STUDENT = "TOTAL_STUDENT";
export const LIST_STUDENTS = "LIST_STUDENTS";
export const GET_STUDENT = "GET_STUDENT";
export const EDIT_STUDENT = "EDIT_STUDENT";
export const STUDENT_ERROR = "STUDENT_ERROR";
// Scribe Requests
export const ADD_SCRIBE = "ADD_SCRIBE";
export const TOTAL_SCRIBE = "TOTAL_SCRIBE";
export const LIST_SCRIBES = "LIST_SCRIBES";
export const LIST_SCRIBES_BY_VOLUNTEER = "LIST_SCRIBES_BY_VOLUNTEER";
export const LIST_SCRIBES_BY_STUEDNT = "LIST_SCRIBES_BY_STUEDNT";
export const GET_SCRIBE = "GET_SCRIBE";
export const EDIT_SCRIBE = "EDIT_SCRIBE";
export const SCRIBE_ERROR = "SCRIBE_ERROR";
// Projects
export const ADD_PROJECT = "ADD_PROJECT";
export const TOTAL_PROJECT = "TOTAL_PROJECT";
export const LIST_PROJECTS = "LIST_PROJECTS";
export const GET_PROJECT = "GET_PROJECT";
export const EDIT_PROJECT = "EDIT_PROJECT";
export const PROJECT_ERRORS = "PROJECT_ERRORS";
export const CLEAR_PROJECT = "CLEAR_PROJECT";

// Propasals
export const ADD_PROPOSAL = "ADD_PROPOSAL";
export const TOTAL_PROPOSALS = "TOTAL_PROPOSALS";
export const LIST_PROPOSALS = "LIST_PROPOSALS";
export const GET_PROPOSAL = "GET_PROPOSAL";
export const EDIT_PROPOSAL = "EDIT_PROPOSAL";
export const PROPOSAL_ERRORS = "PROPOSAL_ERRORS";
export const GET_PROPOSAL_BY_VOLUNTEER = "GET_PROPOSAL_BY_VOLUNTEER";
// VOLUNTEER REQUEST

export const ADD_VOLUNTEER_REQUEST = "ADD_VOLUNTEER_REQUEST";
export const LIST_VOLUNTEER_REQUESTS_BY_VOLUNTEER =
  "LIST_VOLUNTEER_REQUESTS_BY_VOLUNTEER";
export const LIST_VOLUNTEER_REQUESTS_BY_STUDENT =
  "LIST_VOLUNTEER_REQUESTS_BY_STUDENT";
export const TOTAL_VOLUNTEER_REQUESTS = "TOTAL_VOLUNTEER_REQUESTS";
export const LIST_VOLUNTEER_REQUESTS = "LIST_VOLUNTEER_REQUESTS";
export const GET_VOLUNTEER_REQUEST = "GET_VOLUNTEER_REQUEST";
export const RESET_SINGLE_VOLUNTEER = "RESET_SINGLE_VOLUNTEER";
export const EDIT_VOLUNTEER_REQUEST = "EDIT_VOLUNTEER_REQUEST";
export const VOLUNTEER_REQUESTS_ERRORS = "VOLUNTEER_REQUESTS_ERRORS";
// WISH REQUESTS
export const ADD_WISH_REQUESTS = "ADD_WISH_REQUESTS";
export const LIST_WISH_REQUESTS_BY_VOLUNTEER =
  "LIST_WISH_REQUESTS_BY_VOLUNTEER";
export const LIST_WISH_REQUESTS_BY_STUDENT = "LIST_WISH_REQUESTS_BY_STUDENT";
export const TOTAL_WISH_REQUESTS = "TOTAL_WISH_REQUESTS";
export const LIST_WISH_REQUESTSS = "LIST_WISH_REQUESTSS";
export const GET_WISH_REQUESTS = "GET_WISH_REQUESTS";
export const EDIT_WISH_REQUESTS = "EDIT_WISH_REQUESTS";
export const WISH_REQUESTS_ERRORS = "WISH_REQUESTS_ERRORS";

export const PROPOSALS_BY_REQUEST_ID = "PROPOSALS_BY_REQUEST_ID";
//Testimonaials
export const GET_TESTIMONIALS = "GET_TESTIMONIALS";
export const TOTAL_TESTIMONIALS = "TOTAL_TESTIMONIALS";
export const ADD_TESTIMONIAL = "ADD_TESTIMONIAL";
export const EDIT_TESTIMONIAL = "EDIT_TESTIMONIAL";
export const GET_TESTIMONIAL = "GET_TESTIMONIAL";
export const TESTIMONIALS_ERROR = "TESTIMONIALS_ERROR";
// Media coverage
export const GET_MEDIA_COVERAGES = "GET_MEDIA_COVERAGES";
export const TOTAL_MEDIA_COVERAGES = "TOTAL_MEDIA_COVERAGES";
export const ADD_MEDIA_COVERAGE = "ADD_MEDIA_COVERAGE";
export const EDIT_MEDIA_COVERAGE = "EDIT_MEDIA_COVERAGE";
export const GET_MEDIA_COVERAGE = "GET_MEDIA_COVERAGE";
export const MEDIA_COVERAGES_ERROR = "MEDIA_COVERAGES_ERROR";
// Blog
export const GET_BLOGS = "GET_BLOGS";
export const TOTAL_BLOGS = "TOTAL_BLOGS";
export const ADD_BLOG = "ADD_BLOG";
export const EDIT_BLOG = "EDIT_BLOG";
export const GET_BLOG = "GET_BLOG";
export const BLOGS_ERROR = "BLOGS_ERROR";

// Awards
export const GET_AWARDS = "GET_AWARDS";
export const TOTAL_AWARDS = "TOTAL_AWARDS";
export const ADD_AWARD = "ADD_AWARD";
export const EDIT_AWARD = "EDIT_AWARD";
export const GET_AWARD = "GET_AWARD";
export const AWARDS_ERROR = "AWARDS_ERROR";
// Gallery
export const GET_GALLERYS = "GET_GALLERYS";
export const TOTAL_GALLERYS = "TOTAL_GALLERYS";
export const ADD_GALLERY = "ADD_GALLERY";
export const EDIT_GALLERY = "EDIT_GALLERY";
export const GET_GALLERY = "GET_GALLERY";
export const GALLERYS_ERROR = "GALLERYS_ERROR";
export const GET_CURRENT_BENIFICIARYS = "GET_CURRENT_BENIFICIARYS";
export const TOTAL_CURRENT_BENIFICIARYS = "TOTAL_CURRENT_BENIFICIARYS";
export const ADD_CURRENT_BENIFICIARY = "ADD_CURRENT_BENIFICIARY";
export const EDIT_CURRENT_BENIFICIARY = "EDIT_CURRENT_BENIFICIARY";
export const GET_CURRENT_BENIFICIARY = "GET_CURRENT_BENIFICIARY";
export const CURRENT_BENIFICIARYS_ERROR = "CURRENT_BENIFICIARYS_ERROR";

// Cart
export const GET_CARTS = "GET_CARTS";
export const TOTAL_CARTS = "TOTAL_CARTS";
export const ADD_CART = "ADD_CART";
export const EDIT_CART = "EDIT_CART";
export const GET_CART = "GET_CART";
export const CARTS_ERROR = "CARTS_ERROR";

// Order
export const GET_ORDERS = "GET_ORDERS";
export const TOTAL_ORDERS = "TOTAL_ORDERS";
export const ADD_ORDER = "ADD_ORDER";
export const EDIT_ORDER = "EDIT_ORDER";
export const GET_ORDER = "GET_ORDER";
export const ORDERS_ERROR = "ORDERS_ERROR";
